import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

export abstract class LocalStorageService<T> {
  protected localStorageSubject: BehaviorSubject<T>;
  public localStorage: Observable<T>;

  protected constructor(private key: string) {
    this.localStorageSubject = new BehaviorSubject<T>(JSON.parse(localStorage.getItem(this.token)));
    this.localStorage = this.localStorageSubject.asObservable();
  }

  protected get token() {
    return this.key;
  }

  public get value(): T {
    return this.localStorageSubject.value;
  }

  public set value(value: T) {
    if (value) {
      localStorage.setItem(this.token, JSON.stringify(value));
      this.localStorageSubject.next(value);
    } else {
      localStorage.removeItem(this.token);
      this.localStorageSubject.next(null);
    }
  }

  public reset () {
    this.value = null;
  }

  abstract save(value: any);
}
